<template>
  <v-card v-if="actions" class="action-popup" :style="cssVars" v-click-outside="close">
    <v-list class="pa-0">
      <v-list-item-group color="secondary">
        <div v-for="(item, index) in actionItems" :key="index" >
          <v-list-item @click="clickEmit(item.eventName)" :class="item.class + ' rounded-0'">
            <v-list-item-icon class="align-self-center ma-0 mr-3">
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="align-self-center">
              <v-list-item-title class="text--none body-2">{{item.title}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </div>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { EventBus } from '@/router/bus'

export default {
  data () {
    return {
    }
  },
  props: {
    actionItems: Array,
    top: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 20
    },
    actions: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickEmit (eventName) {
      EventBus.$emit(eventName)
    },
    close (e) {
      if (!e.srcElement.className.includes('action--icon')) {
        EventBus.$emit('close-actions')
      }
    }
  },
  computed: {
    cssVars () {
      return 'top: ' + this.top + 'px; right: ' + this.right + 'px;'
    }
  }
}
</script>

<style scoped>
  .action-popup {
    position: absolute;
    width: 260px;
  }
</style>
